/* eslint-disable react/jsx-no-duplicate-props */
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Container } from "react-bootstrap";
import PurchaseOrdersFormVendorInfoView from "./Includes/PurchaseOrdersFormVendorInfoView";
import PurchaseOrdersFormProductsView from "./Includes/PurchaseOrdersFormProductsView";
import PurchaseOrdersFormShippingView from "./Includes/PurchaseOrdersFormShippingView";
import PurchaseOrdersFormFinalizeView from "./Includes/PurchaseOrdersFormFinalizeView";
import { ERROR_WHILE__NAME } from "utlis/AppMessages/AppMessages";
import FeatherIcon from 'feather-icons-react';
import { setGlobalLoading } from "redux/actions/actionCommon";
import uuid from "react-uuid";
import { getFromLocalStorage, saveToLocalStorage } from "utlis/helpers/Common/CommonHelperFunctions";
import { getCartByTemp } from "utlis/Apis/Cart_API";
import { getVendors } from "utlis/Apis/Vendor_API";
import { addCustomerAddress, editCustomerAddress, getCustomerAddresses, getCustomerCountries } from "utlis/Apis/Customers_API";

function PurchaseOrder(props) {
  const submitButtonRef = useRef(null)
  const [goSteps, setGoSteps] = useState(0);
  const [countries, setCountries] = useState([])
  const [vendors, setVendors] = useState([])
  const [addresses, setAddresses] = useState([]);

  const [vendor, setVendor_] = useState({ isNew: false });
  const [bAddress, setBAddress_] = useState({})
  const [sAddress, setSAddress_] = useState({})
  const [order, setOdrer_] = useState({
    shippingCost: 0,
    shippingType: "Regular Shipping",
    payment_processor: "CASH"
  })
  const [lines, setLines] = useState([{}])
  const [token_id, setToken] = useState("")

  document.querySelectorAll(".step-label").forEach((item) => {
    item.setAttribute("style", "font-family: Source Sans Pro, sans-serif");
  });

  useEffect(() => {
    let tempId = getFromLocalStorage("temp_vendor_id")
    if (!tempId) {
      tempId = uuid()
      setToken(tempId)
      saveToLocalStorage("temp_vendor_id", tempId)
    } else {
      setToken(tempId)
      const c = JSON.parse(getFromLocalStorage("temp_vendor")) || {}
      setVendor(c)
      setBAddress(JSON.parse(getFromLocalStorage("temp_vendor_ba")) || {})
      setSAddress(JSON.parse(getFromLocalStorage("temp_vendor_sa")) || {})
      setOrder(JSON.parse(getFromLocalStorage("temp_vendor_order")) || {})
      getCart_(tempId)
      getVendorAddresses_(c.vendor_id)
    }
    getVendor_()
    getCountries_()
  }, [])

  const getVendorAddresses_ = (vendor_id) => {
    if (!vendor_id) {
      return
    }
    getCustomerAddresses(props.currentUser.userToken, vendor_id).then(res => {
      const addressData = res.data
      if (addressData.success) {
        setAddresses(arr => addressData.data)
        setBAddress(addressData.data.filter(e => e.is_default && e.address_type === "Billing")[0] || addressData.data.filter(e => e.address_type === "Billing")[0] || {})
        setSAddress(addressData.data.filter(e => e.is_default && e.address_type === "Shipping")[0] || addressData.data.filter(e => e.address_type === "Shipping")[0] || {})

      }
      if (addressData.error) {
        console.log('Error occured while loading admin groups!', res)
      }
    }).catch(err => {
      console.log(`${ERROR_WHILE__NAME} getAddresses `, err.message)
    })
  }

  const setVendor = (c) => {
    saveToLocalStorage("temp_vendor", JSON.stringify(c))
    setVendor_(c)
  }
  const setSAddress = (data) => {
    data.address_type = "Shipping"
    saveToLocalStorage("temp_vendor_sa", JSON.stringify(data))
    setSAddress_(data)
  }
  const setBAddress = (data) => {
    data.address_type = "Billing"
    saveToLocalStorage("temp_vendor_ba", JSON.stringify(data))
    setBAddress_(data)
  }
  const setOrder = (data) => {
    saveToLocalStorage("temp_vendor_order", JSON.stringify(data))
    setOdrer_(data)
  }
  const getVendor_ = () => {
    getVendors(props.currentUser.userToken).then(res => {
      const resData = res.data
      if (resData && resData.success) {
        setVendors(resData.data)
      }
      if (resData && resData.error) {
      }
    }).catch(err => {
      console.log(`${ERROR_WHILE__NAME} getVendors `, err.message)
    })
  }
  const getCart_ = (id) => {
    getCartByTemp(props.currentUser.userToken, id).then(res => {
      const resData = res.data
      if (resData && resData.success) {
        const list = []
        resData.data.content.forEach(e => {
          list.push(e)
        })
        list.push({})
        setLines(arr => list)
      }
      if (resData && resData.error) {
      }
    }).catch(err => {
      console.log(`${ERROR_WHILE__NAME} getVendors `, err.message)
    })
  }

  const getCountries_ = () => {
    getCustomerCountries().then(res => {
      const countriesData = res.data
      if (countriesData.success) {
        setCountries(countriesData.data)
      }
      if (countriesData.error) {
        console.log('Error occured while loading countries groups!', res)
      }
    }).catch(err => {
      console.log(`${ERROR_WHILE__NAME} getCountries `, err.message)
    })
  }

  const saveAddresses = (address) => {
    saveAddress(bAddress, true)
    saveAddress(address, false)
  }
  const saveAddress = (address, isBilling) => {
    if (address.saveToVendorAddressBook || !address.address_id) {
      address.vendor_id = vendor.vendor_id

      if (!address.shipping_fax) {
        // address.shipping_fax = address.shipping_phone
      }
      if (!address.shipping_mobile) {
        // address.shipping_mobile = address.shipping_phone
      }
      if (isBilling) {
        address.is_default = (addresses.filter(e => e.is_default && e.address_type === "Billing").length > 0) ? 0 : 1
      } else {
        address.is_default = (addresses.filter(e => e.is_default && e.address_type === "Shipping").length > 0) ? 0 : 1
      }
      if (!address.address_id) {
        addCustomerAddress(props.currentUser.userToken, address).then(res => {
          address.address_id = res.data.data || res.data.address_id
          if (isBilling) {
            setBAddress(address)
          } else {
            setSAddress(address)
          }
        }).catch(err => { })
      } else {
        editCustomerAddress(props.currentUser.userToken, address).then(res => { }).catch(err => { })
      }
    }
  }

  const handleFormSubmission = (ev) => {
    ev.preventDefault()
    submitButtonRef.current.click()
  }

  return (
    <section
      id="app-saleOrders__create-details"
      className="st-def-mar-TB"
    >
      <Container fluid className="st-container">
        <div className="app-saleOrders__create-details">
          <div className="app-header-wrapper mb-4">
            <p className="app-heading text-capitalize">Create Purchase Order</p>
            <p className="app-desc">Create a purchase order.</p>
          </div>
          <div
            className="sale-content-container">
            <div className="sale-order-steps">
              <div className="sale-order-stepper">
                <div className="stepper-container">
                  <div className="stepper-step">
                    <button className={`${goSteps === 0 ? "active" : "completed"}`}>
                      <span className="stepper-label">
                        {goSteps === 0 ? "1" :
                          <FeatherIcon
                            icon="check"
                            size="18"
                            className="icon position-relative"
                            style={{ strokeWidth: 4 }}
                          />}
                      </span>
                    </button>
                    <div className={`stepper-title ${goSteps === 0 ? "active" : "completed"}`}>
                      <span className="step-label" style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>
                        Vendor Info
                      </span>
                    </div>
                  </div>
                </div>

                <div className="stepper-container">
                  <div className="vertical-border active">
                    <span className={`center-border ${goSteps === 0 ? "active" : "completed"}`}></span>
                  </div>
                  <div className="stepper-step">
                    <button className={`${goSteps > 1 ? "completed" : goSteps !== 0 ? "active" : goSteps === 0 ? "" : ""}`}>
                      <span className="stepper-label">
                        {
                          goSteps > 1 ? <FeatherIcon
                            icon="check"
                            size="18"
                            className="icon position-relative"
                            style={{ strokeWidth: 4 }}
                          /> :
                            goSteps !== 0 ? "2" :
                              goSteps === 0 ? "2" : ""
                        }

                      </span>
                    </button>
                    <div className={`stepper-title ${goSteps > 1 ? "completed" : goSteps !== 0 ? "active" : goSteps === 0 ? "" : ""}`}>
                      <span className="step-label " style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>Products</span>
                    </div>
                  </div>
                </div>

                <div className="stepper-container">
                  <div className="vertical-border">
                    <span className={`center-border ${goSteps > 1 ? "completed" : goSteps === 1 ? "active" : ""}`}></span></div>
                  <div className="stepper-step">
                    <button className={`${goSteps > 2 ? "completed" : goSteps !== 0 && goSteps !== 1 ? "active" : goSteps === 0 && goSteps === 1 ? "" : ""}`}>
                      <span className="">
                        {
                          goSteps > 2 ? <FeatherIcon
                            icon="check"
                            size="18"
                            className="icon position-relative"
                            style={{ strokeWidth: 4 }}
                          /> :
                            goSteps !== 0 && goSteps !== 1 ? "3" : "3"
                        }
                      </span>

                    </button>
                    <div className={`stepper-title ${goSteps > 2 ? "completed" : goSteps !== 0 && goSteps !== 1 ? "active" : goSteps === 0 && goSteps === 1 ? "" : ""}`}>
                      <span className="step-label " style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>Shipping</span>
                    </div>
                  </div>
                </div>

                <div className="stepper-container">
                  <div className="vertical-border">
                    <span className={`center-border ${goSteps === 3 ? "completed" : goSteps === 2 ? "active" : ""}`}></span></div>
                  <div className="stepper-step">
                    <button className={`${goSteps === 3 ? "active" : ""}`}>
                      <span className="">
                        4
                      </span>
                    </button>
                    <div className={`stepper-title ${goSteps === 3 ? "active" : ""}`}>
                      <span className="step-label" style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>Finalize</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* {saleOrder.vendor.isNew ? "y" : "n"} */}
            {goSteps === 0 && (
              <PurchaseOrdersFormVendorInfoView
                setGoSteps={setGoSteps}
                vendor={vendor}
                bAddress={bAddress}
                sAddress={sAddress}
                setVendor={(data) => {
                  setVendor(data)
                }}
                setBAddress={(data) => {
                  setBAddress(data)
                }}
                setSAddress={(data) => {
                  setSAddress(data)
                }}

                vendors={vendors}
                countries={countries}
                bAddress={bAddress}
                sAddress={sAddress}
                addresses={addresses}
                setAddresses={setAddresses}
                handleFormSubmission={handleFormSubmission}
                saveAddresses={saveAddresses}
              />
            )}
            {goSteps === 1 && (
              <PurchaseOrdersFormProductsView
                setGoSteps={setGoSteps}
                token_id={token_id}
                lines={lines}
                setLines={setLines}
                vendor={vendor}
                bAddress={bAddress}
                sAddress={sAddress}
                getCart={() => {
                  getCart_(token_id)
                }}
              />
            )}
            {goSteps === 2 && (
              <PurchaseOrdersFormShippingView
                setGoSteps={setGoSteps}
                vendor={vendor}
                bAddress={bAddress}
                sAddress={sAddress}
                setSAddress={(data) => {
                  setSAddress(data)
                }}
                token_id={token_id}
                addresses={addresses}
                setAddresses={setAddresses}
                getAddresses={() => { getVendorAddresses_(vendor.vendor_id) }}
                order={order}
                setOrder={(data) => {
                  setOrder(data)
                }}
              />
            )}
            {goSteps === 3 && (
              <PurchaseOrdersFormFinalizeView
                setGoSteps={setGoSteps}
                vendor={vendor}
                bAddress={bAddress}
                sAddress={sAddress}
                setBAddress={(data) => {
                  setBAddress(data)
                }}
                setSAddress={(data) => {
                  setSAddress(data)
                }}
                countries={countries}
                lines={lines}
                token_id={token_id}
                setLines={setLines}
                order={order}
                setOrder={setOrder}
                saveAddresses={saveAddresses}
              />
            )}
          </div>
        </div>
      </Container >
    </section >
  );
}

const getDataFromStore = (state) => {
  return {
    currentUser: state.auth.currentUser,
    sideBarVisibility: state.common.sideBarVisibility,
  };
};

const dispatchActionsToProps = (dispatch) => {
  return {
    setGlobalLoading: (bool) => dispatch(setGlobalLoading(bool)),
  };
};

export default connect(getDataFromStore, dispatchActionsToProps)(PurchaseOrder);
